<app-header></app-header>
<app-side-bar></app-side-bar>
<mat-drawer-container class="example-container">
  <mat-drawer position="end" #drawer mode="side">
    <div>
      <div class="text-center w-100 btn btn-primary p-4 m-0">
        Questions List
        <a class="float-end" (click)="drawer.close()">
          <svg class="bi" width="40" height="16">
            <use xlink:href="#close"></use>
          </svg>
        </a>
      </div>
    </div>

    <div class="list-group">
      <a
        *ngFor="let ques of questions; let i = index"
        class="list-group-item list-group-item-action"
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{ ques.speaker }}</h5>
          <small class="text-muted">{{
            ques.created_at | date: "shortTime"
          }}</small>
        </div>
        <p class="mb-1">{{ ques.question }}</p>
        <small class="text-muted">{{ ques.user }}</small>
      </a>
    </div>
  </mat-drawer>
  <mat-drawer-content>
<div class="row">
        <div class="col-8 offset-2">
          <div class="container-fluid p-0">
            <!-- start title -->
            <div class="row">
              <div class="col-12 h2 pane-heading">
              <!--<img src="./assets/img/logo.png" style="margin-left:10px; margin-right: 10px;" />-->  
           
      
              </div>
              <div class="col-12 h3 mt-md-5 mt-sm-5 pane-heading ">
            <br>
              ACUVUE® OASYS MAX 1-DAY MULTIFOCAL for ASTIGMATISM
              </div>
               <!-- <div class="col-12 h5">
                 <br>
              <br>2nd February 2026 (14:00-16:00 UAE time) <br>9th February 2026 (11:00-13:00 UAE time)<br>11th February 2026 (14:00-16:00 UAE time)
              </div>-->
            </div>
            <!-- End title -->
            <!-- start timer -->
            <div class="row">
           <div class="col-12 p-0">
  <div class="timer-layout-container">
    <app-timer style="--timer-origin: left center"></app-timer>
  </div>
</div>
            <!-- End timer -->
            <!-- start Btn Vedio -->
            <div class="row mb-2">
              <div class="col-12 mb-2">
              <!-- <button
                  class="btn btn-primary mb-2 mr-2 pr-2"
                  style="margin-right: 10px; width: 160px"
                  type="button"
                  (click)="scroll(agenda)"
                >
                  Agenda
                </button>-->

                <a
                  class="btn btn-primary mb-2 mr-2"
                  (click)="openDialog('')"
                  style="margin-right: 10px; width: 160px"
                >
                  Submit a Question
                </a>

                <a
                  *ngIf="is_admin"
                  style="margin-right: 10px; width: 160px"
                  class="btn btn-primary mb-2 float-md-end"
                  (click)=null
                >
                  Question List
                
                </a>
               <!-- <button
                  mat-button
                  [matMenuTriggerFor]="menu"
                  class="float-sm-start float-md-end"
                  style="background-color: #ffca2c; width: 160px"
                >
                  Previous Webinars
                </button>-->
                <mat-menu #menu="matMenu">
                
                  <a mat-menu-item [routerLink]="['/show-vimeo/5791849']">
                  </a>
                </mat-menu>
                
              </div>
            </div>
            <!-- End Btn Vedio -->
            <!-- start Vedio -->
            <div class="row mb-5">
              <div class="col-12">
                
                  <div  class="ratio ratio-16x9">
                    <iframe
                      class="embed-responsive-item" 
 [src]="'https://vimeo.com/event/5791849/embed' | safeUrl"                      frameborder="0"
                      webkitallowfullscreen
                      mozallowfullscreen
                      allowfullscreen
                    ></iframe>
                  
                  </div>
               
              

                <div *ngIf="live_type == 'youtube'">
                  <div *ngIf="youtube" class="ratio ratio-16x9">
                    <iframe
                      class="embed-responsive-item"
                      [src]="
                        'https://www.youtube.com/embed/' +
                          youtube +
                          '?autoplay=1&rel=0' | safeUrl
                      "
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      frameborder="0"
                      allow="autoplay"
                      allowfullscreen
                    ></iframe>
                    <div class="corner-bottom-right"></div>
                    <div class="corner-bottom-right-subscript"></div>
                    <div class="corner-top-right d-none d-lg-block"></div>
                    <div class="corner-top-left d-none d-lg-block"></div>

                    <div class="corner-top-right-mobile"></div>
                    <div class="corner-top-left-mobile"></div>
                  </div>
                </div>
              </div>
            </div>
         <!--
            <div class="row mb-5 agenda" #agenda>
              <div class="col-12">
                <h2 class="text-center">Agenda</h2>

                <br />
                <table class="table table-striped table-hover p-3 m-2">
                  <tbody>
                    <tr>
                    
                      <th>Topic</th>
                      <th>Speaker</th>
                      <th>Duration</th>
                     
                    </tr>
                    <tr>
                   
                      <td>Introduction</td>
                      <td>Sales Team: 
James Grudgings & Raef Mansour
</td>
                      <td>15 mins</td>
                      <td></td>
                    </tr>
                    <tr>
                    
                      <td>Product Training
                        </td>
                      <td>PED:
Sangita Amin

                      </td>
                      <td>75 mins</td>
                    </tr>
    
                    <tr>
                      
                      <td>FAQs & Closing</td>
                      <td>All 
                        </td>
                      <td>30 mins</td>
                    </tr>
                   
                   
                  </tbody>
                </table>
              </div>
            </div>
            

 
            <div class="row  mb-5">
              <div class="col-md-4 ">
               
             
                  <div class="card">
                  <div class="card-header bg-transparent text-center">
                    Speaker
                  </div>
                  <img
                    src="./assets/img/rachelkam.jpg"
                    class="card-img-top"
                    alt="..."
                  />
                  <div class="card-body">
                    <h5 class="card-title">Speaker 1</h5>
                    <p class="card-text">
                      Speaker designation <br />Workplace <br/>
                      Country
                
                    </p>
                  </div>
                </div>
              </div>
               <div class="col-md-4 ">
               
             
                  <div class="card">
                  <div class="card-header bg-transparent text-center">
                    Speaker
                  </div>
                  <img
                    src="./assets/img/rachelkam.jpg"
                    class="card-img-top"
                    alt="..."
                  />
                  <div class="card-body">
                    <h5 class="card-title">Speaker 2</h5>
                    <p class="card-text">
                      Speaker designation <br />Workplace <br/>
                      Country
                
                    </p>
                  </div>
                </div>
              </div>
               <div class="col-md-4 ">
               
             
                  <div class="card">
                  <div class="card-header bg-transparent text-center">
                    Speaker
                  </div>
                  <img
                    src="./assets/img/rachelkam.jpg"
                    class="card-img-top"
                    alt="..."
                  />
                  <div class="card-body">
                    <h5 class="card-title">Speaker 3 </h5>
                    <p class="card-text">
                      Speaker designation <br />Workplace <br/>
                      Country
                
                    </p>
                  </div>
                </div>
              </div>
          
             
              
            </div>
-->
            <!-- End Biography -->
            
            <!-- start pico 
            <div class="row">
              <div class="col-md-6">
                <br />
                <div class="p-2 pt-0" style="font-size: larger">
                  <h4 class="desc-heading mb-1">Description</h4>
                  <p>
                    This webinar is designed to introduce sNPWT in high risk
                    surgeries. During this webinar the faculty will be
                    presenting surgical site infection management
                  </p>
                  <br />
                  <h4 class="desc-heading mb-1">Participant profile</h4>
                  <p>
                    Surgeons and clinical nurse specialists with an interest in
                    managing wound complications
                  </p>
                  <br />
                  <h4 class="desc-heading mb-1">Learning objectives</h4>
                  <p>
                    By attending this webinar, participants will be able to:
                  </p>
                  <ul>
                    <li>
                      Understand how to introduce sNPWT in high risk surgeries
                      to reduce surgical site complications
                    </li>
                    <li>
                      The usage for single patient use negative-pressure devices
                      in improving wound care in closed incisions
                    </li>
                  </ul>

                  <br />
                </div>
              </div>
              <div class="col-md-6" style="background-color: #fff">
                <img
                  src="assets/img/pcioname.jpeg"
                  class="img-fluid p-4"
                  style="width: 400px"
                  alt=""
                />
                <br /><br />
                <img src="assets/img/pico7.png" class="img-fluid" alt="" />
              </div>
            </div>
           End pico  -->
          </div>
              <!-- container end-->
<div class="container pt-5 table-responsive" >
    <table class="table">
          <tbody>
            <tr>
              <td>
    


    
* Source: 2025 GFK sell out data, global 12 markets. 1. JJV Data on File 2025, World’s First and Only Daily Disposable Multifocal Toric Contact Lens.
<br><br>Important Safety Information: ACUVUE® Contact Lenses are indicated for vision correction. As with any contact lenses, eye problems, including corneal ulcers, can develop. Some wearers may experience mild irritation, itching or discomfort. Contact lenses should not be used in case of eye infections or any other eye conditions, or in case of a systemic disease that may affect the eye. For detailed product information, including contraindications, precautions and adverse reactions, please consult the Instructions for Use available on Johnson & Johnson website jnjvisionpro.com/en-me/. For any additional information, please visit our Johnson & Johnson Vision website jnjvisionpro.com/en-me/
<br><br>ACUVUE®, ACUVUE® OASYS MAX 1-Day MULTIFOCAL for ASTIGMATISM, OptiBlue™ and TearStable™ are registered trademarks of Johnson & Johnson.
<br><br>Third-party trademarks used throughout are the property of their respective owners. © Johnson & Johnson Middle East, Inc. 2026.
<br>
© Johnson & Johnson Middle East, Inc. 2026.
<br>
    <br>
              </td>
            </tr>
          </tbody>
        </table>

    
  </div>
  <div class="footer m">
    <img src="./assets/img/bottom.png" class="blob-bright img-fluid" />
  </div>
        </div>
        
      </div>